import { applyMixins } from '../../util/mixins';
import { StockLocationEntity } from '../common/entity';
import { WithCustomFields } from '../custom_field/customField';

export class Container extends StockLocationEntity {
  identifier!: string;
  binId!: string;
  containerTypeId!: string;
  parentId?: string;
  labels: string[] = [];
  deleteOnOutbound: boolean = false;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId, obj.stockLocationId || '');
    Object.assign(this, obj);
    this.customFields = WithCustomFields.toCustomFieldsMap(obj);
  }
}

export interface Container extends WithCustomFields {}
applyMixins(Container, [Container, WithCustomFields]);
